import request from "../request"
//查询详细内容
export function getContentDetail(data) {
    return request({
      url: '/news/' + data.id,
      method:'get',
    //   params:data
    })
 }


// WEBPACK FOOTER //
// ./src/api/detail.js